import React, {useState} from 'react'
import {useSelector} from 'react-redux'
import _ from 'lodash'
import ButtonBuyQuantity from '../UI/button/ButtonBuyQuantity'
import {selectPartsInBasket} from './partsInBasketSlice'
import isAuthorized from '../../utils/constants/isAuthorized'
import searchParams from '../../utils/constants/searchParams'
import parseStyles from '../../utils/helpers/parseStyles'
import {priceSortField, deliverySortField} from './sortSlice'
import {isMobile} from 'react-device-detect'
import ReactTooltip from 'react-tooltip'

const PartListGroup = ({parts}) => {
    const partsInBasket = useSelector(selectPartsInBasket)

    let loc = window.localStorage.locationCity !== null ?
        window.localStorage.locationCity
        : document.querySelector(".cur-location").innerText;

    if (loc !== null) {
        _.chain(parts)
            .sort((a, b) => a.supplier_title === loc ? -1 : b.supplier_title === loc ? 1 : 0)
            .value();
    }

    const defaultLimit = searchParams['SHOW_BRAND_PARTS']
    const maxLimit = 10000
    const [limit, setLimit] = useState(defaultLimit)

    const partsCnt = _.chain(parts).size().value()

    const partsLimited = _.chain(parts).slice(0, limit).value()

    const hiddenParts = _.slice(parts, limit)
    const hiddenMinDeliveryPart = _.minBy(hiddenParts, deliverySortField)

    const iteratees = [priceSortField]
    iteratees.unshift((part) => part[priceSortField] <= 0) // Parts with zero price always in the end
    const hiddenMinPricePart = _.first(_.orderBy(hiddenParts, iteratees))

    const showMore = (e) => setLimit(maxLimit)
    const hideMore = (e) => setLimit(defaultLimit)

    return (
        <div className="result-table__parts">
            {partsLimited.map((part, index) => (
                <div
                    className="result-table__part"
                    style={parseStyles(searchParams['SUPPLIERS_CSS'][part.supplier_id])}
                    key={part.hash}
                >
                    {searchParams['NOT_AVAILABLE_SUPPLIERS'].includes(part['supplier_id']) ? (
                        <div className="result-table__part-cell not-available">
                            {searchParams['TEXT_NOT_AVAILABLE_SUPPLIERS']}
                        </div>
                    ) : (
                        <>
                            {isAuthorized && (
                                <div className="result-table__part-cell supplier">
                                    <span className="turncate" data-text={part.supplier_title}>
                                        {part.supplier_title}
                                    </span>
                                </div>
                            )}
                            <div className="result-table__part-cell in-stock">
                                <span data-tip data-for={part.hash}>
                                    {part.supplier_title === "На заказ"
                                        ? "под заказ"
                                        : isAuthorized
                                            ? part.quantity
                                            : part.quantity > 100
                                                ? '>100'
                                                : part.quantity}
                                </span>
                                {part.last_import_date && (
                                    <ReactTooltip id={part.hash} place="bottom" effect="solid">
                                        {part.last_import_date}
                                    </ReactTooltip>
                                )}
                            </div>
                            <div className="result-table__part-cell delivery">

                                {part.supplier_id === "35"
                                    ? <span data-tip data-for="tooltip_delivery">в пути</span>
                                    : part.delivery_time}
                            </div>
                            <div className="result-table__part-cell price">
                                {part.kentek_price_type === 'price_20' && (
                                    <span className="part-tag-sale">%</span>
                                )}
                                {part.price_src <= 0 ? (
                                    isMobile ? (
                                        'Узнать'
                                    ) : (
                                        <span data-tip data-for="tooltip_part_zero_price">
                                            Узнать
                                        </span>
                                    )
                                ) : (
                                    part.price
                                )}
                            </div>
                            <div className="result-table__part-cell action">
                                <ButtonBuyQuantity
                                    part={part}
                                    basketInfo={
                                        _.has(partsInBasket, [part.basket_hash])
                                            ? partsInBasket[part.basket_hash]
                                            : 0
                                    }
                                />
                            </div>
                        </>
                    )}
                </div>
            ))}
            {partsCnt > limit && (
                <div className="show-more-wrapper">
                    <div className="result-table__part-cell supplier">
                        <button className="show-more__btn" onClick={showMore}>
                            Еще предложения
                            <svg
                                width="12"
                                height="8"
                                viewBox="0 0 12 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M6 0L0 6L1.41 7.41L6 2.83L10.59 7.41L12 6L6 0Z"
                                    fill="black"
                                />
                            </svg>
                        </button>
                    </div>
                    <div className="result-table__part-cell in-stock"></div>
                    <div className="result-table__part-cell delivery">
                        <span className="show-more-delivery">
                            {' '}
                            от {hiddenMinDeliveryPart.delivery_time}
                        </span>
                    </div>
                    <div className="result-table__part-cell tag"></div>
                    <div className="result-table__part-cell price">
                        {hiddenMinPricePart.price_src > 0 && (
                            <span className="show-more-price">от {hiddenMinPricePart.price}</span>
                        )}
                    </div>
                    <div className="result-table__part-cell action"></div>
                </div>
            )}
            {partsCnt > defaultLimit && limit === maxLimit && (
                <div className="show-more-wrapper">
                    <button className="show-more__btn hide" onClick={hideMore}>
                        Свернуть
                        <svg
                            width="12"
                            height="8"
                            viewBox="0 0 12 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M6 0L0 6L1.41 7.41L6 2.83L10.59 7.41L12 6L6 0Z" fill="black"/>
                        </svg>
                    </button>
                </div>
            )}
        </div>
    )
}

export default PartListGroup
